import type { SubtypeAvailable } from '@/api/curatorSubtypes';

/**
 * Набор подтипов куратора для админского блока (D40, договор
 * `docs/CONTRACTS/curator-groups.md` §1).
 *
 * ⚠️ PUT ЗАМЕНЯЕТ НАБОР ЦЕЛИКОМ. Экран всегда шлёт полный список — послать один
 * новый подтип значит снять у куратора все прежние, и увидит это не админ, а сам
 * куратор, у которого назавтра пропали курсы.
 *
 * Правила нормализации — зеркало серверных: пробелы по краям и повторы
 * отбрасываются, порядок по алфавиту.
 */

export function normalizeSubtypes(list: readonly string[]): string[] {
  const seen = new Set<string>();
  for (const raw of list) {
    const s = (raw ?? '').trim();
    if (s) seen.add(s);
  }
  return [...seen].sort();
}

export function toggleSubtype(list: readonly string[], subtype: string): string[] {
  const set = new Set(normalizeSubtypes(list));
  if (!set.delete(subtype)) set.add(subtype);
  return normalizeSubtypes([...set]);
}

/** Набор изменился? Порядок не важен — сравниваем как множества. */
export function subtypesChanged(saved: readonly string[], draft: readonly string[]): boolean {
  const a = normalizeSubtypes(saved);
  const b = normalizeSubtypes(draft);
  return a.length !== b.length || a.some((s, i) => s !== b[i]);
}

/**
 * Подтипы куратора, которых больше нет ни у одного живого курса: сервер ответит
 * `unknown_subtype`, и честнее сказать об этом до нажатия, а не после.
 *
 * Пока список доступных не пришёл — молчим: иначе на долю секунды все подтипы
 * объявляются устаревшими.
 */
export function staleSubtypes(saved: readonly string[], available: readonly SubtypeAvailable[] | undefined): string[] {
  if (!available) return [];
  const live = new Set(available.map((a) => a.subtype));
  return normalizeSubtypes(saved).filter((s) => !live.has(s));
}
